module.exports = __webpack_public_path__ + "img/40-ABITO-RIBOLLA-SML-COLORI-LINO1.6e7189f1.jpg";